import React from 'react'
import { Link } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Carousel from 'react-multi-carousel'
import { locations } from 'components/brands/landingPage/brandDataHelper'
import 'react-multi-carousel/lib/styles.css'

export const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
}

const homePageLocations = (props) => {
  const { isMobile } = props

  return (
    <div className='mb-6'>
      <h2 className={`is-size-4 has-text-weight-extra-bold mb-4 has-black-dark-text ${isMobile ? 'has-text-centered mt-2' : ''}`}>
        Popular Riding Destinations
      </h2>
      <div>
        <Carousel infinite={true} shouldResetAutoplay={false} responsive={responsive}>
          {locations?.map((location, i) => (
            <span
              key={'locationMobile' + i}
            >
              <Link to={`listings/${location.listName}`}>
                <Grid xs={12} textAlign="center">
                  <img
                    alt={location.city + 'Img'}
                    src={location.image}
                    className="location-image-carousel"
                  />
                  <div className="home-page-location-names">{location.city}</div>
                </Grid>
              </Link>
            </span>
          ))}
        </Carousel>
      </div>
    </div>
  )
}

export default homePageLocations
